import { LocalStorageService } from './../services/local-storage.service';
import { LanguageService } from './../services/language.service';
import { User } from './../interfaces/user.model';
import { UserService } from './../services/user.service';
import { Company } from './../interfaces/company.model';
import { CompanyService } from './../services/company.service';
import { AuthService } from './../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CartService } from '../services/cart.service';
import { ApiService } from './../services/api.service';
import { ResponseService } from './../services/response.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  companies: Company[];
  company: Company;
  unreadMessages: any;
  user: User;
  language;
  cart: Boolean;
  onCart: Boolean;
  authenticated: Boolean;
  cartOrCheckout: Boolean;

  // Events Subscribers
  private authSubcriber: any;
  private companySubscriber: any;

  constructor(
    private apiService: ApiService,
    private responseService: ResponseService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private authService: AuthService,
    private userService: UserService,
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    private cartService: CartService,
    private router: Router,
  ) { 
      this.unreadMessages = 0;
      this.authService.isAuth().toPromise().then((auth) => {
        if (auth) {
          return Promise.resolve(true);
        }
        return Promise.resolve(false);
      });
      router.events.subscribe(val => {
        if(val instanceof NavigationEnd){
          this.cart = false;
          this.onCart = (val.urlAfterRedirects && val.urlAfterRedirects.match(/offer/) != null) || val.url.match(/offer/) != null;
          if(!this.onCart){
            if(this.cartService.checkIsActiveCart()){
              this.cart = true;      
            }
          }
          this.cartOrCheckout = ((val.urlAfterRedirects && val.urlAfterRedirects.match(/offer|checkout/) != null) || val.url.match(/offer|checkout/) != null);
        }
      });
  }

  locationChanged(){
    this.apiService.get('/company/' + this.company.id + '/unread-messages').subscribe(
      (response) => {
        this.unreadMessages = this.responseService.success(false, response, 'count');
      },
      (error) => {}
    )
  }

  ngOnInit() {
    this.language = this.languageService.getLanguage();
    this.translate.use(this.language);
    
    this.cartOrCheckout = !(this.router.url.match(/(offer)|(checkout)/) != null);
    this.authSubcriber = this.authService.getAuthenticatedEmitter().subscribe(
      (auth) => {
        if (this.authenticated !== auth) {
          this.triggerRefresh(auth);
        }
        this.authenticated = auth;
      }
    );
    
    this.companySubscriber = this.companyService.getSelectedCompanyEmitter().subscribe(
      (company: Company) => {
        this.company = company;
        // console.log(this.company);

        if(this.company || this.companies){
          this.apiService.get('/company/' + (this.company ? this.company.id : this.companies[0].id) + '/unread-messages').subscribe(
            (response) => {
              this.unreadMessages = this.responseService.success(false, response, 'count');
            },
            (error) => {}
          )
        }
      }
    );


    

  }
 
  triggerRefresh(auth) {
    if (auth) {
      this.userService.getUser().subscribe(
        (user: User) => {
          this.user = user;
        }
      );
      this.companyService.getUserCompanies().subscribe(
        (companies: Company[]) => {
          this.companies = companies;
        }
      );
      
    } else {
      this.user = null;
      this.companies = null;
      this.unreadMessages = 0;
    }
  }

  logout(event) {
    this.authService.logout();
    this.userService.clearUser();
    this.localStorageService.remove('company');
  }

  changeLanguage(language) {
    this.translate.use(language);
    this.languageService.setLanguage(language);
    this.language = language;
  }

  changeCompany(companyID) {
    this.localStorageService.set('company', companyID);
    location.reload();
  }

  ngOnDestroy() {
    this.authSubcriber.unsubscribe();
    this.companySubscriber.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header.component.ts